import { createSelector } from '@ngrx/store';
import { get } from '../../../shared/utils/func';
import { featureState } from './feature.name';

export const lookupsState = createSelector(featureState, get('lookups'));

export const foundUserInfo = createSelector(lookupsState, get('found'));
export const inviteLookupPending = createSelector(lookupsState, get('pending'));
